/**
 * Opens the Judge.me "write a review" modal when the product page is reached with
 * ?resena=1 — the link in the WhatsApp review request — so the customer lands on
 * the form instead of the top of the page.
 *
 * Judge.me only wires its button once the widget has scrolled into view, so the
 * widget is scrolled to first and the click is retried until the modal shows up.
 */
(() => {
  if (new URLSearchParams(window.location.search).get('resena') !== '1') return;

  const maxAttempts = 20;
  const retryMs = 500;

  const modalIsOpen = () => {
    const overlay = document.querySelector('.jdgm-write-review-modal__overlay');
    return Boolean(overlay && overlay.offsetParent !== null);
  };

  const tryOpen = (attempt, scrolled) => {
    if (modalIsOpen() || attempt > maxAttempts) return;

    const widget = document.getElementById('judgeme_product_reviews');
    const button = widget && widget.querySelector('.jdgm-write-rev-link');
    if (widget && !scrolled) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // The first click goes one round after the scroll, once Judge.me has wired it.
    if (button && scrolled) button.click();

    setTimeout(() => tryOpen(attempt + 1, scrolled || Boolean(widget)), retryMs);
  };

  window.addEventListener('load', () => tryOpen(0, false));
})();
